// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hc-ui .person_record_drawer .person_record .person_record--page_content{padding:0 22px}.hc-ui .person_record_drawer .person_record--details_window{left:0}.hc-ui .person_record_drawer .person_record--details_window_bottom_shadow{top:278px}.hc-ui .person_record_drawer .person_record-size_496_plus .person_record--page_content{padding-left:44px;padding-right:44px}.hc-ui .person_record_drawer .person_record-size_768_plus .person_relationship_card.ui.card{margin-top:0}\n", ""]);
// Exports
module.exports = exports;
